/* ===== Anadita Luxe — accessible mega-menu ===== */
(function () {
  'use strict';
  var triggers = [].slice.call(document.querySelectorAll('[data-mega-trigger]'));
  triggers.forEach(function (trigger) {
    var item = trigger.closest('.has-mega');
    var panel = item ? item.querySelector('[data-mega-panel]') : null;
    if (!panel) return;
    var closeTimer = null;
    function open() { panel.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { panel.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    // Small grace period so a quick diagonal mouse move to a sub-item doesn't dismiss the panel.
    function scheduleClose() { closeTimer = window.setTimeout(close, 220); }
    function cancelClose() { if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; } }
    item.addEventListener('mouseenter', cancelClose);
    trigger.addEventListener('click', function (e) {
      if (window.innerWidth < 990) return;
      e.preventDefault();
      var isOpen = panel.classList.contains('is-open');
      triggers.forEach(function (t) { var p = t.closest('.has-mega').querySelector('[data-mega-panel]'); if (p) p.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) open();
    });
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); trigger.focus(); } });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.has-mega')) {
      document.querySelectorAll('[data-mega-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });
})();
